import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW1709Model } from "./kymw1709.model";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { GetUploadImageInfoService } from "./api-services/get-upload-image-info.service";

/**
 * アップロード画像確認画面を管理するクラス
 * 
 * @export KYMW1709Component
 * @class KYMW1709Component
 */
@Component({
  selector: 'app-kymw1709',
  templateUrl: 'kymw1709.component.html',
  styleUrls: ['kymw1709.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1709Component extends PlessViewHelperSub implements OnInit {
 
  kymw1709Model: KYMW1709Model = new KYMW1709Model();

  constructor(
    private kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getUploadImageInfoService: GetUploadImageInfoService,
  ){
    super(kymw00Model);
  }

  /**
   * 親画面からの値
   * 
   * @param param   画像ファイル名
   */
  setParameter(param) {
    this.kymw1709Model.imageFileName = param;
  }

  /**
   * 初期処理
   * 
   */
  ngOnInit(): void {
    this.componentName = "KYMW1709";
    this.kymw1709Model.kymw1709Component = this;

    this.getUploadImageInfoService.execute(this.kymw1709Model);
  }
}